var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#07086E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7035 22.027C20.2425 22.027 19.0536 20.7736 19.0536 19.2333C19.0536 17.6932 20.2425 16.4397 21.7035 16.4397C23.1645 16.4397 24.3535 17.6932 24.3535 19.2333C24.3535 20.7736 23.1645 22.027 21.7035 22.027ZM27.1345 13.1917C25.6535 11.5809 23.7245 10.6943 21.7025 10.6943C19.6805 10.6943 17.7506 11.582 16.2686 13.1938C14.7646 14.8289 13.9386 17.0259 14.0036 19.2207C14.1076 22.746 16.3696 25.3193 18.3656 27.589C19.8885 29.3199 21.2025 30.8148 21.2025 32.3054H22.2025C22.2025 30.7684 23.5195 29.2925 25.0435 27.5826C27.0375 25.3467 29.2985 22.8124 29.4025 19.2207C29.4665 17.0248 28.6395 14.8268 27.1345 13.1917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationBlue);
export default __webpack_public_path__ + "static/media/ic_location_blue.3b8bc5f5a47ecaa56f54e55cc0e5fd70.svg";
export { ForwardRef as ReactComponent };